import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { Provider } from 'react-redux'
import { persistor, store } from './store'
import { PersistGate } from 'redux-persist/integration/react'

// 빌드 시점에 박힌 환경변수 — 브라우저 console 에 출력
// (CRA 정적 빌드라 docker logs 에는 안 찍힘. 브라우저 DevTools 의 Console 에서 확인)
console.log('===================================')
console.log('pathfinder frontend startup')
console.log('===================================')
console.log('  NODE_ENV =', process.env.NODE_ENV)
console.log('  REACT_APP_API_SERVER =', process.env.REACT_APP_API_SERVER)
console.log('===================================')

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  // React.StrictMode를 셋팅하면
  // - 안전하지 않은 생명주기를 사용하는 컴포넌트 발견
  // - 레거시 문자열 ref 사용에 대한 경고
  // - 권장되지 않는 findDOMNode 사용에 대한 경고
  // - 예상치 못한 부작용 검사
  // - 레거시 context API 검사
  // 를 수행한다. 단 두번 렌더링 되어서 로그가 두번찍히거나 성능상의 문제가 생길 수 있다.
  // 개발환경에서만 사용되고 배포환경에서는 사용되지 않는다.
  // <React.StrictMode>
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
  // </React.StrictMode>
)
